import React from "react";
import classNames from "classnames";
import { HelpIndicator } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { defaultMultiManagerPoweredByMessage } from "apps/common/authentication/common/LoginCard/constants";
import jsqIcon from "../jsq.svg";
import styles from "./styles.scss";

type Props = {
  message?: string;
  helpMessage?: string;
};

export const AccountActivationCardHeader: React.FC<Props> = ({
  message = "Access powered by",
  helpMessage = defaultMultiManagerPoweredByMessage,
}) => {
  return (
    <p
      className={classNames(
        styles.AccountActivationCardHeader__container,
        "text-md align-center",
      )}
    >
      <span>{message}</span>{" "}
      <img
        alt="Juniper Square"
        src={jsqIcon}
        className={classNames(styles.AccountActivationCardHeader__jsqIcon, "inline-xs")}
      />{" "}
      <span>
        <HelpIndicator placement="right" data-cy="help-icon" content={helpMessage}>
          <Icon type="question-circle" size="small" variant="outline" />
        </HelpIndicator>
      </span>
    </p>
  );
};

export default AccountActivationCardHeader;
